export class Toggle_Show_More {
  constructor() {
    const showMoreContainer = document.querySelector('.show-more-container');
    if (!showMoreContainer){
      return;
    }
    const showMoreTitle = showMoreContainer.querySelector('h2');
    const showMoreContent = showMoreContainer.querySelector('p');
    const showMoreToggle = showMoreContainer.querySelector('.show-more-button');

    let titleHeight = showMoreTitle.scrollHeight;
    let contentHeight = showMoreContent.scrollHeight;
    let toggleHeight = showMoreToggle.scrollHeight;

    contentHeight > 120
      ? showMoreContainer.classList.add('toggleable')
      : showMoreContainer.classList.remove('toggleable')

    showMoreToggle.onclick = function () {
      showMoreContainer.classList.toggle('active');
      setContainerHeight();
      setButtonText();
    }

    window.addEventListener("resize", function () {
      getContainerHeight();
      if (contentHeight > 120) {
        showMoreContainer.classList.add('toggleable');
        setContainerHeight();
      } else {
        showMoreContainer.classList.remove('toggleable');
        removeContainerHeight();
      }
    });


    function getContainerHeight() {
      titleHeight = showMoreTitle.scrollHeight;
      contentHeight = showMoreContent.scrollHeight;
      toggleHeight = showMoreToggle.scrollHeight;
    }

    function setContainerHeight() {
      showMoreContainer.style.height = showMoreContainer.classList.contains('active') ? `${titleHeight + contentHeight + toggleHeight + 34}px` : '140px';
    }

    function removeContainerHeight() {
      showMoreContainer.style.height = '';
    }

    function setButtonText() {
      showMoreToggle.querySelector('span').innerHTML = showMoreContainer.classList.contains('active') ? 'Toon minder' : 'Toon meer';
    }
  }

}
